/* eslint-disable @typescript-eslint/explicit-function-return-type */

const EVENTS = "__events";

export interface EventObject {
    type: string;
    eventName: string;
}

type EventCallback = (event: EventObject, ...args: any) => void;
type EventsCallbackList = {
    [event: string]: EventCallback[];
};

export default {
    /**
     * Register a callback for an event
     */
    on(event: string, callback: EventCallback) {
        let events: EventsCallbackList | undefined = this[EVENTS];
        if (!events) {
            events = {};
            this[EVENTS] = events;
        }

        if (!events[event]) {
            events[event] = [];
        }

        events[event].push(callback);

        return this;
    },

    /**
     * Fire an event and pass all additional parameters into the callback.
     */
    trigger(event: string, ...args: any) {
        let events: EventsCallbackList | undefined = this[EVENTS];
        if (!events || !events[event]) {
            return this;
        }

        // Add an event object to the callback parameters
        args.unshift({
            type: event,
            eventName: event,
        });

        events[event].forEach((fn) => fn.apply(this, args));

        return this;
    },

    /**
     * Removes a callback
     * @param event The name of the event to remove the callback from
     * @param callback Exact reference to the callback to be removed
     */
    off(event: string, callback: EventCallback) {
        let events: EventsCallbackList | undefined = this[EVENTS];
        if (!events || !events[event]) {
            return this;
        }

        events[event] = events[event].filter((fn) => fn != callback);

        return this;
    },
};
